export interface ECUDataInterface {
    programData: Record<string, any>;
    moduleData: Record<string, any>;
    machineToVariantData: Record<string, any>;
    prefilledJSONContent: Record<string, any>;
    prefilledJSONContentBackup: Record<string, any>;
}

export const ECUDataTemplate: ECUDataInterface = {
    programData: {},
    moduleData: {},
    machineToVariantData: {},
    prefilledJSONContent: {},
    prefilledJSONContentBackup: {}
};